// https://swiperjs.com/get-started
import SwiperCore, { Navigation, Pagination, Scrollbar, EffectFade, Autoplay } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Scrollbar, EffectFade, Autoplay]);
import 'swiper/swiper-bundle.css';


const swiper1 = new SwiperCore('.swiper--testimonials', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    effect: 'fade',
    // fadeEffect: {
    //   crossFade: true
    // },

    // If we need pagination
    pagination: {
        el: '.swiper-pagination-testimonial',
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper--next',
    },
});

new SwiperCore('.swiper--eventsgallery', {
    direction: 'horizontal',
    loop: true,
    loopAdditionalSlides: 5,
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
});

$('.event--gallery--inner').each(function() {
  var swipereventsgallery = $(this).find('.swiper--eventsgallery')[ 0 ].swiper;
    $(this).mouseenter(function(){
      swipereventsgallery.params.autoplay.delay = 500;
      swipereventsgallery.params.speed = 700;
      swipereventsgallery.autoplay.start();
    })
    $(this).mouseleave(function(){
      swipereventsgallery.autoplay.stop();
    })
});


const swipercover = new SwiperCore('.swiper--events', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    autoplay: {
      delay: 5000,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper--next',
        // prevEl: '.swiper--prev',
    },
  
});

$(document).ready(function(){  

  const swiper = new SwiperCore('.swiper--schritte', {
      direction: 'horizontal',
      loop: false,
      pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            var count = index + 1;
            return '<div class="' + className + '"><span class="schritt-counter ">' + count + '</span></div>';            
          },
      },   
  });

  
    setTimeout(function(){
      const logosSlider = new SwiperCore('.swiper--logos', {
        //   direction: 'horizontal',
          loop: true,
          slidesPerView: 2.8,
          spaceBetween: 40,
          speed: 4000,
          pauseOnMouseEnter: false,
          autoplay: {
            delay: 1,
            disableOnInteraction: false,
          },
          breakpoints: {
            768: {
              slidesPerView: 3.2,
            }
          },
      });
  }, 1000);
  

  
  })